import { combineReducers } from 'redux';

import { subdomainReducer } from './subdomain';
import { IApplicationState, TReduxActions } from '../types/redux';
import { geoLocationReducer } from './geoLocation';
import { seoReducer } from './seo';
import { pageReducer } from './page';
import { userReducer } from './user';
import { filterJsonQueryReducer } from './filterJsonQuery';
import { queryStringReducer } from './queryString/queryStringReducer';

export const reducers = combineReducers<IApplicationState, TReduxActions>({
  geoLocation: geoLocationReducer,
  seo: seoReducer,
  subdomain: subdomainReducer,
  page: pageReducer,
  user: userReducer,
  filterJsonQuery: filterJsonQueryReducer,
  queryString: queryStringReducer,
});
